module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.title),
      expression: "title"
    }],
    staticClass: "weui-cells__title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._t("after-title"), _vm._v(" "), _c('div', {
    staticClass: "weui-cells weui-cells_checkbox"
  }, _vm._l((_vm.currentOptions), function(one, index) {
    return _c('label', {
      staticClass: "weui-cell weui-check_label",
      class: {
        'vux-checklist-label-left': _vm.labelPosition === 'left'
      },
      attrs: {
        "for": ("checkbox_" + _vm.uuid + "_" + index)
      }
    }, [_c('div', {
      staticClass: "weui-cell__hd"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.currentValue),
        expression: "currentValue"
      }],
      staticClass: "weui-check",
      attrs: {
        "type": "checkbox",
        "name": ("vux-checkbox-" + _vm.uuid),
        "id": ("checkbox_" + _vm.uuid + "_" + index),
        "disabled": _vm.ifDisable(_vm.getKey(one))
      },
      domProps: {
        "value": _vm.getKey(one),
        "checked": Array.isArray(_vm.currentValue) ? _vm._i(_vm.currentValue, _vm.getKey(one)) > -1 : (_vm.currentValue)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.currentValue,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = _vm.getKey(one),
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.currentValue = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.currentValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.currentValue = $$c
          }
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "weui-icon-checked vux-checklist-icon-checked"
    })]), _vm._v(" "), _c('div', {
      staticClass: "weui-cell__bd"
    }, [_c('p', {
      domProps: {
        "innerHTML": _vm._s(_vm.getValue(one))
      }
    })])])
  })), _vm._v(" "), _vm._t("footer")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e58a936"}!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/checklist/index.vue
// module id = 516
// module chunks = 4